import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class BonusDto implements IBonusDto {
    id!: number;
    yearMonth!: string | undefined;
    monthDate!: Date;
    bonusPercentage!: number;
    employeeId!: number;
    employee!: EmployeeSummaryDto;
    fromMonth!: string | undefined;
    toMonth!: string | undefined;
    fromMonthDate!: Date;
    toMonthDate!: Date;
    bonusGross!: number;
    bonusAmount!: number;
    incentiveBonus!: number;
    totalBonus!: number;
    remark!: string | undefined;

    constructor(data?: IBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.bonusPercentage = _data["bonusPercentage"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.fromMonthDate = _data["fromMonthDate"] ? new Date(_data["fromMonthDate"].toString()) : <any>undefined;
            this.toMonthDate = _data["toMonthDate"] ? new Date(_data["toMonthDate"].toString()) : <any>undefined;
            this.bonusGross = _data["bonusGross"];
            this.bonusAmount = _data["bonusAmount"];
            this.incentiveBonus = _data["incentiveBonus"];
            this.totalBonus = _data["totalBonus"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): BonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new BonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["bonusPercentage"] = this.bonusPercentage;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["fromMonthDate"] = this.fromMonthDate ? this.fromMonthDate.toISOString() : <any>undefined;
        data["toMonthDate"] = this.toMonthDate ? this.toMonthDate.toISOString() : <any>undefined;
        data["bonusGross"] = this.bonusGross;
        data["bonusAmount"] = this.bonusAmount;
        data["incentiveBonus"] = this.incentiveBonus;
        data["totalBonus"] = this.totalBonus;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IBonusDto {
    id: number;
    yearMonth: string | undefined;
    monthDate: Date;
    bonusPercentage: number;
    employeeId: number;
    employee: EmployeeSummaryDto;
    fromMonth: string | undefined;
    toMonth: string | undefined;
    fromMonthDate: Date;
    toMonthDate: Date;
    bonusGross: number;
    bonusAmount: number;
    incentiveBonus: number;
    totalBonus: number;
    remark: string | undefined;
}

